(function () {
    angular.module("metaNavTicketWidgetComponent", ["moviesServiceModule", "theatresServiceModule", "popoverController"])
        .component("ticketWidget", {
            templateUrl: "/Scripts/app/meta-nav-ticket-widget/ticket-widget.template.html",
            bindings: {
                ticketButtonUrl: "@",
                widgetTitle: "@",
                movieNowPlayingLabel: "@",
                moviePlaceholder: "@",
                movieInputPrompt: "@",
                theatreFavLabel: "@",
                theatreSearchedLabel: "@",
                theatreNearLabel: "@",
                theatreOtherLabel: "@",
                theatrePlaceholder: "@",
                theatreInputPrompt: "@",
                dateAvailableLabel: "@",
                datePlaceholder: "@",
                dateInputPrompt: "@",
                todayText: "@",
                tomorrowText: "@",
                movieNotFoundError: "@",
                theatreNotFoundError: "@",
                findShowtimeButtonText: "@",
                languageCode: "@"
            },
            controller: ["moviesService", "theatresService", "connectFunctions", "$scope", "$q","$timeout", "$element", ticketWidgetController]
        });

    function ticketWidgetController(moviesService, theatresService, connectFunctions, $scope, $q, $timeout, $element) {
        //VARIABLES
        var self = this;
        var sideDrawerId = '#meta-nav-drawer';

        self.movieOptions = [];
        self.allMovieOptions = null;
        self.selectedMovie = '';
        self.noMovieResults = false;
        self.selectMovieDisabled = true;

        self.theatreOptions = [];
        self.allTheatreOptions = null;
        self.selectedTheatre = '';
        self.noTheatreResults = false;
        self.selectTheatreDisabled = true;

        self.dateOptions = [];
        self.selectedDate = '';
        self.selectDateDisabled = true;
        self.isSeriesTicketing = false;
        self.isVipSeriesTicketing = false;
        self.searchStartPoint = '';

        self.showtimesDetailsUrl = '';
        self.submitFindShowtimes = submitFindShowtimes;

        self.originalScroll = 0;

        //INITIALIZE
        self.$onInit = onInitFunction;
        $scope.$on('initTicketWidget', getDropdownOptions);

        function onInitFunction() {
            initSelectizeComponent();
        }

        function initSelectizeComponent() {
            //Define settings for slectize movies dropdown
            self.selectizeMovieOptions = {
                optgroups: [{ id: 'movie', name: self.movieNowPlayingLabel }],
                placeholder: self.moviePlaceholder,
                title: self.moviePlaceholder,
                labelField: 'text',
                valueField: 'id',
                searchField: ['text'],
                optgroupField: 'type',
                optgroupLabelField: 'name',
                optgroupValueField: 'id',
                onDropdownOpen: movieDropdownOnOpen,
                onType: setNoMovieResults,
                onBlur: clearErrors,
                onDropdownClose: movieDropdownOnClose
            };
            //Define settings for slectize theatres dropdown
            self.selectizeTheatreOptions = {
                optgroups: [
                    { id: 'fav', name: self.theatreFavLabel },
                    { id: 'searched', name: self.theatreSearchedLabel },
                    { id: 'nearBy', name: self.theatreNearLabel },
                    { id: 'regular', name: self.theatreOtherLabel }
                ],
                placeholder: self.theatrePlaceholder,
                title: self.theatrePlaceholder,
                labelField: 'text',
                valueField: 'id',
                searchField: ['searchTerm'],
                optgroupField: 'type',
                optgroupLabelField: 'name',
                optgroupValueField: 'id',
                optGroupOrder: ['fav', 'searched', 'nearBy', 'regular'],
                lockOptgroupOrder: true,
                onDropdownOpen: theatreDropdownOnOpen,
                onType: setNoTheatreResults,
                onBlur: clearErrors,
                onDropdownClose: theatreDropdownOnClose
            };
            //Define settings for slectize dates dropdown
            self.selectizeDateOptions = {
                optgroups: [{ id: 'date', name: self.dateAvailableLabel }],
                placeholder: self.datePlaceholder,
                title: self.datePlaceholder,
                labelField: 'text',
                valueField: 'id',
                searchField: ['text'],
                optgroupField: 'type',
                optgroupLabelField: 'name',
                optgroupValueField: 'id',
                onInitialize: initDateInput,
                onDropdownOpen: dateDropdownOnOpen,
                onDropdownClose: dateDropdownOnClose
            };

            //When a selectize input dropdown receives focus, scroll to it so its suggested list is in view
            $element.find('selectize-input').focusin(function (event) {
                var currentScroll = $(sideDrawerId).scrollTop();
                var relativeOffset = $(event.target).closest('selectize-input').offset().top - $(sideDrawerId).offset().top + currentScroll;
                if (relativeOffset - currentScroll >= 1) {
                    $(sideDrawerId).animate({
                        scrollTop: relativeOffset
                    }, 200);
                }
            });
        }

        //FUNCTIONS
        //#region Movies
        function getMovieOptions() {
            self.selectMovieDisabled = true;
            self.selectedDate = '';
            self.selectDateDisabled = true;
            if (self.allMovieOptions) {
                getMoviesSuccess(self.allMovieOptions);
            } else {
                getMovieOptionsPromise().then(getMoviesSuccess, showError);
            }
        }

        function getMovieOptionsPromise() {
            return moviesService.getAllMoviesWithShowtimes({ Take: 1000, Skip: 0, language: self.languageCode });
        }

        function getMoviesSuccess(response) {
            self.movieOptions = mapMovieObjects(response.data);
            self.selectMovieDisabled = false;
        }

        function mapMovieObjects(movieObjects) {
            var result = [];

            movieObjects.forEach(function (movie) {
                result.push(new movieObject(movie.filmName, movie.filmId, movie.movieUtcDates, "movie", movie.seriesTicketingUrl, movie.seriesTicketingVIPUrl));
            });

            return result;
        };

        function movieObject(name, id, dates, type, seriesTicketingUrl, seriesTicketingVIPUrl) {
            return {
                text: name,
                id: id,
                movieUtcDates: dates || [],
                type: type,
                seriesTicketingUrl: seriesTicketingUrl,
                seriesTicketingVIPUrl: seriesTicketingVIPUrl
            };
        };

        function movieDropdownOnOpen() {
            var temp = this;
            var selectizeElement = temp.$wrapper.parent();
            updateDropdownStyleOnOpen(selectizeElement);
            temp.$input.data("selectize").clear(false);
            setOriginalScroll();
        }

        function movieDropdownOnClose() {
            var temp = this;
            var selectizeElement = temp.$wrapper.parent();
            updateDropdownStyleOnClose(selectizeElement);
            resetToOriginalScroll();
        }
        //get movies for theater
        function updateMovieDropdownOptions(newVal) {
            if (newVal) {
                if (!self.selectedMovie) {
                    getMoviesForTheatre(parseInt(newVal));
                }
                else {
                    self.dateOptions = formatDateResults(getSelectedItem(self.theatreOptions, newVal, "id").movieUtcDates);
                    self.selectDateDisabled = false;
                }
            }
            else {
                if (self.searchStartPoint && self.searchStartPoint != 'movie') {
                    self.selectedMovie = '';
                    getMovieOptions();
                }
            }
        };
        function getMoviesForTheatre(theatreId) {
            self.selectMovieDisabled = true;
            self.searchStartPoint = 'theatre';
            self.selectedDate = '';
            self.selectDateDisabled = true;
            moviesService.getTheatreMoviesWithDates(theatreId, self.languageCode).then(getMoviesForTheatreSuccess, showError);
        }

        function getMoviesForTheatreSuccess(response) {
            self.movieOptions = mapMovieObjects(response);
            self.selectMovieDisabled = false;
        }
        //#endregion

        //#region Theatres
        function getTheatresOptions() {
            self.selectTheatreDisabled = true;
            self.selectedDate = '';
            self.selectDateDisabled = true;
            if (self.allTheatreOptions) {
                theatresServicesSuccess(self.allTheatreOptions);
            } else {
                $q.all(getTheatresOptionsPromises()).then(theatresServicesSuccess, showError);
            }
        }
        
        function getTheatresOptionsPromises() {
            var getConnectGuidAndTokenResult = connectFunctions.getConnectGuidAndSessToken();
            if (getConnectGuidAndTokenResult.successful) {
                return [theatresService.getTheatresWithFavs(self.languageCode, getConnectGuidAndTokenResult.connectGUID, getConnectGuidAndTokenResult.ccToken), theatresService.getLocalTheatres()];
            }
            else {
                return [theatresService.getAllTheatres(self.languageCode), theatresService.getLocalTheatres()];
            }
        }

        function theatresServicesSuccess(response) {
            var theatreList = mapTheatreObjects(response[0]);
            theatresList = updateTheatreType(theatreList, response[1], "nearBy");
            theatresList = updateHistoricalTheatres(theatresList);
            self.theatreOptions = theatresList;
            self.selectTheatreDisabled = false;
        }
        //get theatres for movie
        function updateTheatreDropdownOptions(newVal) {
            if (newVal) {
                if (!self.selectedTheatre) {
                    getTheatresForMovie(parseInt(newVal));
                }
                else {
                    self.dateOptions = formatDateResults(getSelectedItem(self.movieOptions, newVal, "id").movieUtcDates);
                    self.selectDateDisabled = false;
                }
            }
            else {
                if (self.searchStartPoint && self.searchStartPoint != 'theatre') {
                    self.selectedTheatre = '';
                    getTheatresOptions();
                }
            }
        };

        function getTheatresForMovie(movieId) {
            self.selectTheatreDisabled = true;
            self.searchStartPoint = 'movie';
            self.selectedDate = '';
            self.selectDateDisabled = true;
            var getConnectGuidAndTokenResult = connectFunctions.getConnectGuidAndSessToken();
            if (getConnectGuidAndTokenResult.successful) {
                $q.all([theatresService.getMovieTheatresWithFavs(movieId, self.languageCode, getConnectGuidAndTokenResult.connectGUID, getConnectGuidAndTokenResult.ccToken), theatresService.getLocalTheatres()]).then(getTheatresForMovieSuccess, showError);
            }
            else {
                $q.all([theatresService.getMovieTheatres(movieId, self.languageCode), theatresService.getLocalTheatres()]).then(getTheatresForMovieSuccess, showError);
            }
        }

        function getTheatresForMovieSuccess(response) {
            var theatreList = mapTheatreObjects(response[0]);
            theatresList = updateTheatreType(theatreList, response[1], "nearBy");
            theatresList = updateHistoricalTheatres(theatresList);
            self.theatreOptions = theatreList;
            self.selectTheatreDisabled = false;
        };

        function mapTheatreObjects(theatresArray) {
            var mappedArray = [];
            theatresArray.forEach(function (theatre) {
                //Hacky filtering for Boucherville Drive-in theatre (I don't like how this is done, but I have been left no choice)
                if (parseInt(theatre.locationId) !== 9112) {
                    var theatreType = theatre.isFavourite ? "fav" : "regular";
                    mappedArray.push(new theatreObject(theatre.name, theatre.locationId, theatreType, theatre.city, theatre.province, theatre.movieUtcDates, theatre.seriesTicketingUrl, theatre.seriesTicketingVIPUrl));
                }
            });
            return mappedArray;
        };

        function theatreObject(name, id, type, city, province, movieUtcDates) {
            return {
                text: name,
                id: id,
                type: type,
                searchTerm: name + " " + city + " " + province,
                movieUtcDates: movieUtcDates || [],
            };
        };

        function updateTheatreType(theatreList, updateTheatreList, typeString) {
            for (var i = 0; i < theatreList.length; i++) {
                for (var j = 0; j < updateTheatreList.length; j++) {
                    if (theatreList[i].id === updateTheatreList[j].locationId) {
                        if (theatreList[i].type !== 'fav') {
                            theatreList[i].type = typeString;
                        }
                        j = updateTheatreList.length;
                        updateTheatreList.splice(j, 1);
                    }
                }
                if (updateTheatreList.length === 0) i = theatreList.length;
            }
            return theatreList;
        };

        function updateHistoricalTheatres(theatreList) {
            var searchedTheatres = getHistoricalTheatreSearches();
            var updatedTheatreList = theatreList;
            if (searchedTheatres !== null) {
                updatedTheatreList = updateHistoricalTheatreType(theatreList, searchedTheatres, "searched");
            }
            return updatedTheatreList;
        };

        function getHistoricalTheatreSearches() {
            var searchedTheatres = [];
            var oldSearchedTheatreStorageValues = (hasStorage() === true) ? localStorage.getItem("PreviouslySearchedTheatres") : null;

            if (oldSearchedTheatreStorageValues !== undefined && oldSearchedTheatreStorageValues !== null) {
                searchedTheatres = oldSearchedTheatreStorageValues.split(",");
            }
            else {
                var oldSearchedTheatresCookieValues = $.cookie("PreviouslySearchedTheatres");
                if (oldSearchedTheatresCookieValues !== undefined && oldSearchedTheatresCookieValues !== null) {
                    searchedTheatres = oldSearchedTheatresCookieValues.split(",");
                }
            }
            return searchedTheatres;
        };

        function updateHistoricalTheatreType(theatreList, updateTheatreList, typeString) {
            for (var i = 0; i < theatreList.length; i++) {
                for (var j = 0; j < updateTheatreList.length; j++) {
                    if (theatreList[i].id === parseInt(updateTheatreList[j])) {
                        if (theatreList[i].type !== 'fav') {
                            theatreList[i].type = typeString;
                        }
                        j = updateTheatreList.length;
                        updateTheatreList.splice(j, 1);
                    }
                }
                if (updateTheatreList.length === 0) i = theatreList.length;
            }
            return theatreList;
        };

        function theatreDropdownOnOpen() {
            var temp = this;
            var selectizeElement = temp.$wrapper.parent();
            updateDropdownStyleOnOpen(selectizeElement);
            temp.$input.data("selectize").clear(false);
            setOriginalScroll();
        }

        function theatreDropdownOnClose() {
            var temp = this;
            var selectizeElement = temp.$wrapper.parent();
            updateDropdownStyleOnClose(selectizeElement);
            resetToOriginalScroll();
        }
        //#endregion

        //#region Dates

        function formatDateResults(dates) {
            var movieDates = [];
            $.each(dates, function (index, dateItem) {
                var language = "EN";
                if (self.languageCode === "fr-ca") {
                    language = "FR";
                }
                var englishDate = moment.utc(dateItem, undefined, "EN", true);
                var englishFormat = englishDate.format("ddd, MMM DD YYYY");

                var movieDate = moment.utc(dateItem, undefined, language, true);

                var dateItemFormatted = language === "EN" ? movieDate.format("ddd, MMM DD YYYY") : movieDate.format("ddd MMM DD YYYY"),
                    localTime = moment();

                if (englishDate.format("MM-DD-YYYY") === moment().format("MM-DD-YYYY")) {
                    movieDates.push(new dateObject(index, ("(" + self.todayText + ") " + dateItemFormatted), englishFormat));
                }
                else if (englishDate.format("MM-DD-YYYY") === localTime.add(1, 'days').format('MM-DD-YYYY')) {
                    movieDates.push(new dateObject(index, ("(" + self.tomorrowText + ") " + dateItemFormatted), englishFormat));
                }
                else {
                    movieDates.push(new dateObject(index, dateItemFormatted, englishFormat));
                }
            });
            return movieDates;
        };

        function dateObject(id, text, dateText) {
            return {
                id: id,
                text: text,
                dateText: dateText,
                type: "date"
            };
        }

        function dateDropdownOnOpen() {
            var temp = this;
            var selectizeElement = temp.$wrapper.parent();
            updateDropdownStyleOnOpen(selectizeElement);
            temp.$input.data("selectize").clear(false);
            setOriginalScroll();
        }

        function dateDropdownOnClose() {
            var temp = this;
            var selectizeElement = temp.$wrapper.parent();
            updateDropdownStyleOnClose(selectizeElement);
            resetToOriginalScroll();
        }
        //#endregion

        //#region Selectize Functions
        function getDropdownOptions() {
            var optionsFunctions = [getMovieOptionsPromise()];
            optionsFunctions = optionsFunctions.concat(getTheatresOptionsPromises());

            $q.all(optionsFunctions)
                .then(getDropdownOptionsSuccess, showError);
        }

        function getDropdownOptionsSuccess(response) {
            var movies = response[0];
            self.allMovieOptions = movies;
            getMoviesSuccess(movies);

            var theatres = response.slice(1, 3);
            self.allTheatreOptions = theatres;
            theatresServicesSuccess(theatres);
            $scope.$emit('ticketWidgetInitialized');
        }

        function updateDropdownStyleOnOpen(selectizeElement) {
            if (selectizeElement.siblings('.right-icon-wrap').has('#date-chevron').length) {
                selectizeElement.siblings('.right-icon-wrap').children('#date-chevron').removeClass('fa-chevron-down');
                selectizeElement.siblings('.right-icon-wrap').children('#date-chevron').addClass('fa-chevron-up');
            }
            else {
                selectizeElement.siblings('.right-icon-wrap').children('.fa').hide();
                selectizeElement.siblings('.right-icon-wrap').children('.search-img').show()
            }
            updateDividerLength(selectizeElement);
        };

        function updateDropdownStyleOnClose(selectizeElement) {
            selectizeElement.siblings('.input-dropdown-divider').hide();
            selectizeElement.siblings('.right-icon-wrap').children('.fa').removeClass('fa-chevron-up');
            selectizeElement.siblings('.right-icon-wrap').children('.search-img').hide();
            selectizeElement.siblings('.right-icon-wrap').children('.fa').addClass('fa-chevron-down');
            selectizeElement.siblings('.right-icon-wrap').children('.fa').show();
        };

        function setOriginalScroll() {
            self.originalScroll = $('.body-wrapper').scrollTop();
        }

        function resetToOriginalScroll() {
            $('.body-wrapper').scrollTop(self.originalScroll);
        }

        function clearErrors() {
            self.noMovieResults = false;
            self.noTheatreResults = false;
            $scope.$apply();
        };

        function initDateInput() {
            $(this.$control_input[0]).attr("readonly", "true");
            $(this.$control).css("cursor", "pointer");
            return true;
        };

        function setNoMovieResults() {
            var temp = this;
            if (!temp.hasOptions) {
                self.noMovieResults = true;
            }
            else {
                self.noMovieResults = false;
            }
            $scope.$apply();
        };

        function setNoTheatreResults() {
            var temp = this;
            if (!temp.hasOptions) {
                self.noTheatreResults = true;
            }
            else {
                self.noTheatreResults = false;
            }
            $scope.$apply();
        };
        //#endregion

        //#region General Functions
        $scope.$watch(function () {
            return self.selectedMovie;
        }, updateTheatreDropdownOptions);
        
        $scope.$watch(function () {
            return self.selectedTheatre;
        }, updateMovieDropdownOptions);

        $scope.$watchGroup([
            function () { return self.selectedMovie; },
            function () { return self.selectedTheatre; },
            function () { return self.selectedDate; }],
            generateShowtimesUrl);

        function generateShowtimesUrl(newVal) {
            if (newVal && newVal[0] && newVal[1] && newVal[2]) {
                $('#find-showtimes-button').prop({ disabled: false });
                var requestedDate = self.dateOptions[parseInt(self.selectedDate)].dateText;
                var queryDate = moment.utc(requestedDate, "ddd, MMM DD YYYY").format("MM/DD/YYYY");
                self.showtimesDetailsUrl = '/showtimedetails?locationId=' + self.selectedTheatre +
                    '&filmId=' + self.selectedMovie +
                    '&date=' + queryDate +
                    '&language=' + self.languageCode;
            }
            else {
                $('#find-showtimes-button').prop({ disabled: true });
            }
        }

        function updateDividerLength(selectizeElement) {
            selectizeElement.siblings('.input-dropdown-divider').width(selectizeElement.width() - 32);
            selectizeElement.siblings('.input-dropdown-divider').show();
        }

        function submitFindShowtimes() {
            window.open(self.showtimesDetailsUrl,'_self');
        }

        function getSelectedItem(itemArray, itemId, filterField) {
            return itemArray.filter(function (item) { return item[filterField] === parseInt(itemId); })[0];
        };

        function showError() {
            //TO DO Error Handler
        };

        function hasStorage() {
            try {
                localStorage.setItem("temp", "temp");
                localStorage.removeItem("temp");
                return true;
            }
            catch (exception) {
                return false;
            }
        }
        //#endregion
    };
})();